<script setup lang="ts">
const clearCache = async (): Promise<void> => {
  ["ka", "en", "ru"].forEach((lang) => {
    $fetch(`/api/${lang}`, {
      method: "POST",
      // @ts-ignore
      headers: {
        clearCache: true,
      },
    });

    $fetch(`/api/getIndxL/${lang}`, {
      method: "POST",
      // @ts-ignore
      headers: {
        clearCache: true,
      },
    });

    // $fetch(`/api/getContentDataL${lang}`, {
    //   method: "POST",
    //   // @ts-ignore
    //   headers: {
    //     clearCache: true,
    //   },
    // });
  });

  $fetch("/api/sitemap", {
    method: "POST",
    // @ts-ignore
    headers: {
      clearCache: true,
    },
  });

  $fetch("/api/redirects", {
    method: "POST",
    // @ts-ignore
    headers: {
      clearCache: true,
    },
  });

  $fetch("/api/getThirdPartyScripts", {
    method: "POST",
    // @ts-ignore
    headers: {
      clearCache: true,
    },
  });
};

clearCache();
</script>

<template>
  <div class="clear-cache">
    <span> CACHE CLEARED </span>
  </div>
</template>

<style lang="scss">
@keyframes lights {
  0% {
    color: hsl(230, 40%, 80%);
    text-shadow: 0 0 1em hsla(320, 100%, 50%, 0.2), 0 0 0.125em hsla(320, 100%, 60%, 0.3),
      -1em -0.125em 0.5em hsla(40, 100%, 60%, 0),
      1em 0.125em 0.5em hsla(200, 100%, 60%, 0);
  }

  30% {
    color: hsl(230, 80%, 90%);
    text-shadow: 0 0 1em hsla(320, 100%, 50%, 0.5), 0 0 0.125em hsla(320, 100%, 60%, 0.5),
      -0.5em -0.125em 0.25em hsla(40, 100%, 60%, 0.2),
      0.5em 0.125em 0.25em hsla(200, 100%, 60%, 0.4);
  }

  40% {
    color: hsl(230, 100%, 95%);
    text-shadow: 0 0 1em hsla(320, 100%, 50%, 0.5), 0 0 0.125em hsla(320, 100%, 90%, 0.5),
      -0.25em -0.125em 0.125em hsla(40, 100%, 60%, 0.2),
      0.25em 0.125em 0.125em hsla(200, 100%, 60%, 0.4);
  }

  70% {
    color: hsl(230, 80%, 90%);
    text-shadow: 0 0 1em hsla(320, 100%, 50%, 0.5), 0 0 0.125em hsla(320, 100%, 60%, 0.5),
      0.5em -0.125em 0.25em hsla(40, 100%, 60%, 0.2),
      -0.5em 0.125em 0.25em hsla(200, 100%, 60%, 0.4);
  }

  100% {
    color: hsl(230, 40%, 80%);
    text-shadow: 0 0 1em hsla(320, 100%, 50%, 0.2), 0 0 0.125em hsla(320, 100%, 60%, 0.3),
      1em -0.125em 0.5em hsla(40, 100%, 60%, 0),
      -1em 0.125em 0.5em hsla(200, 100%, 60%, 0);
  }
}

.clear-cache {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: black;

  span {
    display: block;
    font-size: 72px;
    font-family: sans-serif !important;

    animation: lights 5s 750ms linear infinite;
  }
}
</style>
